import { render, staticRenderFns } from "./postsaleODM.vue?vue&type=template&id=39ac86ed&"
import script from "./postsaleODM.vue?vue&type=script&lang=ts&"
export * from "./postsaleODM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports